import GlobusEmptyCollectionError from "./components/GlobusEmptyCollectionError";

type Step = {
    text: string;
    link?: string;
}

export enum GlobusErrorMessageTypeEnum {
    CARD, FULLSCREEN
}

export type SolutionDetails = {
    type: GlobusErrorMessageTypeEnum;
    title: string;
    subtitle: string;
    steps?: Step[];
    component?: Function
}

export const GlobusErrorsSolutions: Record<string, SolutionDetails> = {
    "ExternalError.DirListingFailed.GCDisconnected": {
        type: GlobusErrorMessageTypeEnum.CARD,
        title: "Globus Transfer Error: Connection Required",
        subtitle: "It looks like the Globus Connect Personal app is either not installed or not running on your machine.",
        steps: [
            {
                text: "1. Install Globus Connect Personal if you haven’t already.",
                link: "https://www.globus.org/globus-connect-personal"
            },
            { text: "2. Start the app and ensure it's running before retrying the transfer." }
        ]
    },
    "ClientError.Conflict.GCPaused": {
        type: GlobusErrorMessageTypeEnum.CARD,
        title: "Globus Transfer Error",
        subtitle: "It looks like the Globus Connect Personal app is paused on your machine.",
        steps: [
            { text: "1. Make sure that your Globus Connect Personal app is running on your machine." },
            { text: "2. Unpause the app before retrying the transfer." }
        ]
    },
    "UNAUTHORIZED": {
        type: GlobusErrorMessageTypeEnum.CARD,
        title: "Globus Transfer Permission Required",
        subtitle: "To securely transfer the files you requested, Lasso needs permission to access your Globus share on your behalf.",
        steps: [
            { text: "Lasso initiates file transfers via Globus using your approved access." },
            { text: "This ensures seamless, automated data delivery without requiring manual intervention." },
            { text: "Your data remains secure — Lasso does not store your Globus credentials." },
            { text: "Click \"Authorize\" below to grant Lasso permission to initiate your requested transfers." },
        ]
    },
    "REAUTH_REQUIRED": {
        type: GlobusErrorMessageTypeEnum.CARD,
        title: "Reauthorization Required",
        subtitle: "To securely transfer the files you requested, Lasso needs permission to access your Globus share on your behalf.",
        steps: [
            { text: "To keep your file transfers running smoothly, please reauthorize your Globus account." }
        ]
    },
    "NO_COLLECTIONS_AVAILABLE": {
        type: GlobusErrorMessageTypeEnum.FULLSCREEN,
        title: "Globus share transfer",
        subtitle: "To start your first transfer follow the steps below to setup your Globus Share and create a collection for your transfers.",
        component: GlobusEmptyCollectionError
    }
}